// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"CartAside_placeholder__udFg2","placeholderLabel":"CartAside_placeholderLabel__2Thpu"};